package org.vreo.devicehub.features.device.presentation.addDevice

/**
 * Add device actions
 */
sealed interface AddDeviceActions {
    class OnClearError : AddDeviceActions
    class OnUpdateSelectedProduct(val index: Int) : AddDeviceActions
    class OnUpdateSerialNumber(val value: String) : AddDeviceActions
    class OnUpdateTag(val value: String) : AddDeviceActions
    class OnUpdatePassword(val value: String) : AddDeviceActions
    data class OnAddDevice(val callback: (() -> Unit)? = null) : AddDeviceActions
    class OnBackNavigation : AddDeviceActions
}